import PubmaticReports from "../app/Dashboard/Integrations/PubmaticReports";
import CustomSegmentRuleTable from "../app/Dashboard/Integrations/SwitchTabs/CustomSegmentRuleTable";
import PubmaticDomainsWhitelist from "../app/Dashboard/Integrations/PubmaticDomainsWhitelist";
import PubmaticURLsWhitelist from "../app/Dashboard/Integrations/PubmaticURLsWhitelist";
import PubmaticURLsBlacklist from "../app/Dashboard/Integrations/PubmaticURLsBlacklist";

const tabConstants = {
    "Segments": CustomSegmentRuleTable,
    "Reports": PubmaticReports,
    // "Domains Whitelist": PubmaticDomainsWhitelist,
    "URLs Whitelist": PubmaticURLsWhitelist,
    "URLs Blacklist": PubmaticURLsBlacklist,
}


export {tabConstants}
